/** URL segment for /dashboard/:startupSlug from a company name. */
export function startupNameSlug(companyName: string | undefined | null): string {
  const slug = (companyName || '')
    .trim()
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
  return slug || 'startup';
}

export function startupMatchesNameSlug(startup: { companyName?: string }, slug: string): boolean {
  return startupNameSlug(startup.companyName) === slug;
}
